module.exports = __webpack_public_path__ + "static/media/finger_authen_trans.4ad88fbd.svg";